import { Tabs } from "@hatch-digital-nl/abs-storybook/legacy";
import { useAppSelector, useAppDispatch } from "../../../../app/hooks";
import { JSX, useEffect } from "react";
import { useEmployeeId } from "../../../../common/utils/useEmployeeId";
import { useGetEmployeeByIdQuery } from "../../../../common/api/employee";
import { tabItems } from "../../utils/tabItems";
import { EmployeeCertificatesPagination } from "./EmployeeCertificatesPagination";
import { EmployeeCertificatesContent } from "./EmployeeCertificatesContent";
import { useGetCertificatesQuery } from "../../../../common/api/certificate";
import Skeleton from "react-loading-skeleton";

export const EmployeeCertificatesTable = (): JSX.Element => {
    const dispatch = useAppDispatch();
    const { activeTab, currentPage, itemsPerPage, searchTerm } = useAppSelector(
        (state) => state.achievedQualifications,
    );

    const { isPatchEditCertificateSuccess } = useAppSelector(
        (state) => state.editCertificateModal,
    );

    const { isPostCreateCertificateSuccess } = useAppSelector(
        (state) => state.createCertificateModal,
    );

    const {
        data: employeeData,
        isLoading: employeeDataIsLoading,
        refetch: refetchEmployeeData,
    } = useGetEmployeeByIdQuery({
        id: useEmployeeId(),
    });
    const {
        data: certificateData,
        isLoading: certificateDataIsLoading,
        isFetching: certificateDataIsFetching,
        refetch: refetchCertificateData,
    } = useGetCertificatesQuery({
        page: currentPage,
        items_per_page: itemsPerPage,
        filter: {
            status: activeTab,
            employee_id: useEmployeeId(),
            search: searchTerm,
        },
    });

    useEffect(() => {
        if (isPatchEditCertificateSuccess || isPostCreateCertificateSuccess) {
            refetchEmployeeData();
        }
    }, [
        isPatchEditCertificateSuccess,
        isPostCreateCertificateSuccess,
        refetchEmployeeData,
    ]);

    return (
        <div className={"p-certificates__employee"}>
            {employeeDataIsLoading ? (
                <Skeleton height={"5rem"} count={1} borderRadius={"1.5rem"} />
            ) : (
                <Tabs items={tabItems({ dispatch, employeeData, activeTab })} />
            )}
            <EmployeeCertificatesContent
                certificateData={certificateData?.data}
                certificateDataIsLoading={certificateDataIsLoading}
                certificateDataIsFetching={certificateDataIsFetching}
                refetchCertificateData={refetchCertificateData}
                isPatchEditCertificateSuccess={isPatchEditCertificateSuccess}
                isPostCreateCertificateSuccess={isPatchEditCertificateSuccess}
                activeTab={activeTab}
            />
            <EmployeeCertificatesPagination />
        </div>
    );
};
